import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aff-messages-page',
  templateUrl: './messages-page.component.html',
  styleUrls: ['./messages-page.component.scss']
})
export class MessagesPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
